// Static blog data for Vite
// In a real app, this would be generated at build time

import type { Post } from "@/types/blog";

const staticPosts: Post[] = [
  {
    slug: "welcome",
    metadata: {
      title: "Welcome to My Blog",
      description: "An introduction to my blog and what to expect",
      createdAt: "2024-01-01",
      updatedAt: "2024-01-01",
      category: "general",
    },
    content: "# Welcome\n\nThis is a placeholder blog post.",
  },
  {
    slug: "vite-migration",
    metadata: {
      title: "Migrating from Next.js to Vite",
      description: "How we migrated this site from Next.js to Vite",
      createdAt: "2024-06-26",
      updatedAt: "2024-06-26",
      category: "technical",
    },
    content:
      "# Vite Migration\n\nWe successfully migrated from Next.js to Vite!",
  },
];

export function getAllPosts() {
  return staticPosts.sort(
    (a, b) =>
      new Date(b.metadata.createdAt).getTime() -
      new Date(a.metadata.createdAt).getTime()
  );
}

export function getPostBySlug(slug: string) {
  return getAllPosts().find((post) => post.slug === slug);
}

export function getPostsByCategory(category: string) {
  return getAllPosts().filter((post) => post.metadata?.category === category);
}

export function findNeighbour(posts: Post[], slug: string) {
  const len = posts.length;

  for (let i = 0; i < len; ++i) {
    if (posts[i].slug === slug) {
      return {
        previous: i > 0 ? posts[i - 1] : null,
        next: i < len - 1 ? posts[i + 1] : null,
      };
    }
  }

  return { previous: null, next: null };
}
